export default "__VITE_ASSET__CpfN06ZB__"